<template>
    <v-container>
        <v-card shaped class="mx-md-4 my-md-4 pa-4">
            <v-card-title>
                <v-toolbar flat color="#1d2735" dark style="border-radius: 5px">
                    <v-icon class="white--text" style="font-size: 45px"
                        >mdi-account-supervisor-circle</v-icon
                    >
                    <pre><v-toolbar-title><h2>{{ albaran.id != null ? `Actualizar albarán de venta #${albaran.nro}` : 'Crear albarán de venta' }}</h2></v-toolbar-title></pre>
                </v-toolbar>
            </v-card-title>

            <v-card-text>
                <!-- Datos albaran y datos cliente -->
                <v-form ref="formAlbaran" v-model="validAlbaran">
                    <h2>Datos albarán</h2>
                    <v-row>
                        <v-col cols="12" md="3">
                            <v-text-field
                                @change="checkNro"
                                v-model="albaran.nro"
                                label="Número"
                                :rules="[rules.required, rules.number]"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="2">
                            <date-select
                                v-model="albaran.fecha"
                                label="Fecha"
                                :rules="[rules.required]"
                            ></date-select>
                        </v-col>
                    </v-row>

                    <h2>Datos del cliente</h2>
                    <v-row>
                        <v-col cols="12" md="3">
                            <cliente-select-vue
                                label="Cliente"
                                v-model="albaran.id_cliente"
                                :extra="albaran.cliente"
                                @change="clienteSelected"
                                :rules="[rules.required]"
                            ></cliente-select-vue>
                        </v-col>
                        <v-col cols="6" md="3">
                            <!-- <v-autocomplete
                                readonly
                                v-model="albaran.id_cliente"
                                :items="clientes"
                                item-text="cif"
                                item-value="id"
                                label="CIF"
                            >
                            </v-autocomplete> -->
                            <cliente-select-vue
                                label="CIF"
                                v-model="albaran.id_cliente"
                                item-text="cif"
                                item-value="id"
                                readonly
                            ></cliente-select-vue>
                        </v-col>
                        <v-col cols="6" md="3">
                            <!-- <v-autocomplete
                                readonly
                                v-model="albaran.id_cliente"
                                :items="clientes"
                                item-text="telefono"
                                item-value="id"
                                label="Teléfono"
                            >
                            </v-autocomplete> -->
                            <cliente-select-vue
                                label="Teléfono"
                                v-model="albaran.id_cliente"
                                item-text="telefono"
                                item-value="id"
                                readonly
                            ></cliente-select-vue>
                        </v-col>
                        <v-col cols="6" md="3">
                            <!-- <v-autocomplete
                                readonly
                                v-model="albaran.id_cliente"
                                :items="clientes"
                                item-text="email"
                                item-value="id"
                                label="Email"
                            >
                            </v-autocomplete> -->
                            <cliente-select-vue
                                label="Email"
                                v-model="albaran.id_cliente"
                                item-text="email"
                                item-value="id"
                                readonly
                            ></cliente-select-vue>
                        </v-col>
                        <v-col cols="6" md="3">
                            <!-- <v-autocomplete
                                readonly
                                v-model="albaran.id_cliente"
                                :items="clientes"
                                item-text="direccion_nombre"
                                item-value="id"
                                label="Dirección"
                            >
                            </v-autocomplete> -->
                            <cliente-select-vue
                                label="Dirección"
                                v-model="albaran.id_cliente"
                                item-text="direccion"
                                item-value="id"
                                readonly
                            ></cliente-select-vue>
                        </v-col>
                        <v-col cols="6" md="3">
                            <!-- <v-autocomplete
                                readonly
                                v-model="albaran.id_cliente"
                                :items="clientes"
                                item-text="ciudad_nombre"
                                item-value="id"
                                label="Ciudad"
                            >
                            </v-autocomplete> -->
                            <cliente-select-vue
                                label="Ciudad"
                                v-model="albaran.id_cliente"
                                item-text="ciudad"
                                item-value="id"
                                readonly
                            ></cliente-select-vue>
                        </v-col>
                        <v-col cols="6" md="3">
                            <!-- <v-autocomplete
                                readonly
                                v-model="albaran.id_cliente"
                                :items="clientes"
                                item-text="dir.codigo_postal"
                                item-value="id"
                                label="Código postal"
                            >
                            </v-autocomplete> -->
                            <cliente-select-vue
                                label="Código postal"
                                v-model="albaran.id_cliente"
                                item-text="codigo_postal"
                                item-value="id"
                                readonly
                            ></cliente-select-vue>
                        </v-col>
                        <v-col cols="6" md="3">
                            <!-- <v-autocomplete
                                readonly
                                v-model="albaran.id_cliente"
                                :items="clientes"
                                item-text="dir.provincia_rel.nombre"
                                item-value="id"
                                label="Provincia"
                            >
                            </v-autocomplete> -->
                            <cliente-select-vue
                                label="Provincia"
                                v-model="albaran.id_cliente"
                                item-text="provincia"
                                item-value="id"
                                readonly
                            ></cliente-select-vue>
                        </v-col>
                    </v-row>
                </v-form>

                <!-- Agregar lineas del albaran -->
                <h2>Nueva línea de albarán</h2>
                <v-form ref="formLineas" v-model="validLineas">
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field
                                v-model="linea.descripcion"
                                label="Descripción"
                                :rules="[rules.required]"
                            >
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" md="2">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="linea.cantidad"
                                    type="number"
                                    label="Cantidad"
                                    :rules="[rules.required, rules.min]"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>
                        <v-col cols="12" md="2">
                            <div class="spacing">
                                <v-text-field-comma
                                    v-model="linea.importe"
                                    type="number"
                                    label="Importe"
                                    :rules="[rules.required, rules.min]"
                                >
                                </v-text-field-comma>
                            </div>
                        </v-col>

                        <v-col cols="12" md="2">
                            <v-autocomplete
                                v-model="linea.id_iva"
                                label="IVA"
                                :items="ivas"
                                item-text="descripcion"
                                item-value="id"
                                suffix="%"
                                :rules="[rules.required]"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-btn
                                @click="addLinea()"
                                :disabled="isloading"
                                color="success"
                                class="white--text"
                            >
                                Añadir
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-form>

                <!-- datatable de lineas -->
                <v-row>
                    <v-col cols="12">
                        <v-data-table
                            dense
                            :headers="headers"
                            hide-default-footer
                            disable-pagination
                            :items="albaran.lineas"
                            item-key="id"
                            class="elevation-1"
                        >
                            <template v-slot:item.cantidad="{ item }">
                                {{ item.cantidad | decimalComma }}
                            </template>
                            <template v-slot:item.importe="{ item }">
                                {{ formatPrice(item.importe) }}
                            </template>
                            <template v-slot:item.iva="{ item }">
                                {{ formatPrice(item.valor_iva) }}
                            </template>
                            <template v-slot:item.total="{ item }">
                                {{ formatPrice(item.total) }}
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-icon
                                    @click="openEditDialog(item)"
                                    small
                                    class="mr-2"
                                    color="black"
                                    style="font-size: 25px"
                                    title="EDITAR"
                                    >mdi-pencil-outline</v-icon
                                >

                                <v-icon
                                    @click="openDeleteDialog(item)"
                                    small
                                    class="mr-2"
                                    color="red"
                                    style="font-size: 25px"
                                    title="BORRAR"
                                >
                                    mdi-trash-can
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>

                <!-- Totales -->
                <v-row align="start" justify="end">
                    <v-col cols="8"> </v-col>
                    <v-col cols="12" md="4">
                        <v-card style="min-width: 100%; padding: 1rem">
                            <v-row
                                v-for="(valor, tipoIva) in total"
                                :key="`total-${tipoIva}`"
                            >
                                <v-col cols="6">
                                    <h4 style="text-wrap: nowrap">
                                        Base imponible {{ tipoIva }}%:
                                    </h4>
                                </v-col>
                                <v-col cols="6">
                                    <h4>
                                        <h4
                                            style="
                                                text-wrap: nowrap;
                                                text-align: right;
                                            "
                                        >
                                            {{ formatPrice(valor) }}
                                        </h4>
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-row
                                v-for="(total, tipoIva) in iva"
                                :key="tipoIva"
                            >
                                <v-col cols="6">
                                    <h4>IVA {{ tipoIva }}%:</h4>
                                </v-col>
                                <v-col cols="6">
                                    <h4 style="text-align: right">
                                        {{ formatPrice(total) }}
                                    </h4>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6">
                                    <h4>Total:</h4>
                                </v-col>
                                <v-col cols="6">
                                    <h4
                                        style="
                                            text-wrap: nowrap;
                                            text-align: right;
                                        "
                                    >
                                        {{
                                            formatPrice(
                                                albaran.importe + albaran.iva
                                            )
                                        }}
                                    </h4>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>

                <!-- Observaciones -->
                <v-row>
                    <v-col cols="12">
                        <v-textarea
                            v-model="albaran.observaciones"
                            label="Obersevaciones"
                            outlined
                        >
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-row>
                    <v-col cols="12">
                        <router-link to="lista-albaranes-venta">
                            <v-btn color="red" class="white--text mr-2">
                                Cancelar
                            </v-btn>
                        </router-link>
                        <v-btn
                            v-if="!albaran.id"
                            @click="create()"
                            :disabled="isloading"
                            color="success"
                            class="white--text mr-2"
                            >Guardar</v-btn
                        >
                        <v-btn
                            v-if="albaran.id"
                            @click="update()"
                            :disabled="isloading"
                            color="success"
                            class="white--text"
                            >Actualizar</v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>

        <edit-dialog-vue
            v-model="edit_dialog"
            :item="edit_linea"
            :items_select="ivas"
            @edit="editLinea"
        />

        <delete-dialog-vue
            v-model="delete_dialog"
            :id="edit_linea.index"
            @delete="deleteLinea"
        />
    </v-container>
</template>
<script>
import clienteSelectVue from "../../../components/general/clienteSelect.vue";
import DeleteDialogVue from "./DeleteDialog.vue";
import EditDialogVue from "./EditDialog.vue";
import { formatPrice } from "../../../helpers";

export default {
    components: { clienteSelectVue, EditDialogVue, DeleteDialogVue },
    data() {
        return {
            rules: {
                required: (value) => !!value || "Requerido.",
                min: (value) => {
                    const minValue = 0;
                    return (
                        value > minValue ||
                        `El número debe ser mayor a ${minValue}.`
                    );
                },
                number: (value) =>
                    /^[0-9]+$/.test(value) || "Solo se permiten números.",
            },
            albaran: {
                id: null,
                nro: null,
                id_cliente: null,
                cliente: null,
                fecha: "",
                importe: 0,
                observaciones: "",
                importe: 0,
                iva: 0,
                lineas: [],
            },
            linea: {
                id: null,
                descripcion: "",
                importe: 0,
                cantidad: 1,
                id_iva: null,
                valor_iva: 0,
                total: 0,
            },
            edit_linea: {
                id: null,
                descripcion: "",
                importe: 0,
                cantidad: 1,
                id_iva: null,
                valor_iva: 0,
                total: 0,
            },
            headers: [
                { text: "Descripción", value: "descripcion", sortable: false },
                { text: "Cantidad", value: "cantidad", sortable: false },
                { text: "Importe", value: "importe", sortable: false },
                { text: "IVA", value: "iva", sortable: false },
                { text: "Total", value: "total", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            ivas: [],
            validAlbaran: true,
            validLineas: true,
            edit_dialog: false,
            delete_dialog: false,
        };
    },
    created() {
        this.getIvas();

        if (this.$route.query.id) {
            this.getAlbaran(this.$route.query.id);
        } else {
            this.checkNro();
        }
    },
    methods: {
        getAlbaran(id) {
            axios
                .get(`api/albaran/venta/${id}`)
                .then((res) => {
                    const response = res.data.success;
                    if (response == null) {
                        this.$toast.success("Albarán no encontrado");
                    } else {
                        this.albaran = response;
                        this.clienteSelected(this.albaran.id_cliente);
                    }
                })
                .catch((error) => {
                    console.log("error", error);
                    this.$toast.error(error);
                });
        },
        create() {
            this.$refs.formAlbaran.validate();

            console.log("this.validAlbaran", this.validAlbaran);
            console.log(
                "this.albaran.lineas.length",
                this.albaran.lineas.length
            );
            if (this.validAlbaran && this.albaran.lineas.length > 0) {
                axios
                    .post("api/albaran/venta", this.albaran)
                    .then((res) => {
                        const response = res.data.success;
                        this.$toast.success(response);
                        this.$router.push("lista-albaranes-venta");
                    })
                    .catch((error) => {
                        console.log("error", error);
                        this.$toast.error(error);
                    });
            } else {
                this.$toast.error("Debe agregar al menos una línea");
            }
        },
        update() {
            axios
                .put(`api/albaran/venta/${this.albaran.id}`, this.albaran)
                .then((res) => {
                    const response = res.data.success;
                    this.$toast.success(response);
                })
                .catch((error) => {
                    console.log("error", error);
                    this.$toast.error(error);
                });
        },
        checkNro() {
            axios
                .get(`api/albaran/venta/nro/${this.albaran.nro}`)
                .then((res) => {
                    const response = res.data.success;
                    if (response != null) {
                        this.albaran.nro = response;
                    } else {
                        this.$toast.error(
                            "Error al cargar el número del albarán"
                        );
                    }

                    if (response.message != null) {
                        this.$toast.success(response.message);
                    }
                })
                .catch((error) => {
                    console.log("error", error);
                    this.$toast.error(error);
                });
        },

        addLinea() {
            this.$refs.formLineas.validate();
            if (this.validLineas) {
                this.albaran.lineas.push(this.getLinea(this.linea));
                this.clearLinea();
            }
        },
        getLinea(linea_l) {
            let linea = linea_l;

            const subtotal = linea.importe * linea.cantidad;
            const iva = this.ivas.find(
                (element) => element.id == linea.id_iva
            ).descripcion;
            const valor_iva = (subtotal * parseInt(iva)) / 100;

            linea.valor_iva = valor_iva;
            linea.total = subtotal + valor_iva;

            return JSON.parse(JSON.stringify(linea));
        },
        editLinea(linea_l) {
            let index = linea_l.index;
            let linea = this.getLinea(linea_l);
            this.albaran.lineas[index] = JSON.parse(JSON.stringify(linea));
            this.albaran.lineas = JSON.parse(
                JSON.stringify(this.albaran.lineas)
            );
            this.dialog = false;
        },
        deleteLinea(linea_index) {
            this.albaran.lineas.splice(linea_index, 1);
            this.delete_dialog = false;
        },
        clearLinea() {
            this.linea = {
                id: null,
                descripcion: "",
                importe: 0,
                cantidad: 1,
                id_iva: null,
                valor_iva: 0,
                total: 0,
            };
        },

        getIvas() {
            axios
                .get("api/get-iva")
                .then((res) => {
                    this.ivas = res.data.success;
                })
                .catch((error) => {});
        },

        openEditDialog(item) {
            this.edit_linea = item;
            this.edit_linea.index = this.albaran.lineas.indexOf(item);
            this.edit_dialog = true;
        },
        openDeleteDialog(item) {
            this.edit_linea = item;
            this.edit_linea.index = this.albaran.lineas.indexOf(item);
            this.delete_dialog = true;
        },

        clienteSelected(id) {
            let cliente_selected;
            if (id == this.albaran.cliente?.id) {
                cliente_selected = this.albaran.cliente;
            } else {
                cliente_selected = this.clientes.find(
                    (element) => element.id === id
                );
            }
        },
        formatPrice,
    },
    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        clientes() {
            let clientes_temp = this.$store.getters.getclientes;
            if (this.presupuesto != null)
                if (this.presupuesto.clientela != null) {
                    clientes_temp.push(this.presupuesto.clientela);
                }
            return clientes_temp;
        },
        total() {
            let totales = {};
            this.albaran.lineas.forEach((elemento) => {
                let total_sin_iva = 0;

                let iva = this.ivas.find(
                    (element) => element.id == elemento.id_iva
                ).descripcion;
                total_sin_iva = elemento.total / (1 + parseInt(iva) / 100);
                elemento.iva = iva;

                if (elemento.iva in totales) {
                    totales[elemento.iva] += total_sin_iva;
                } else {
                    totales[elemento.iva] = total_sin_iva;
                }
            });

            // Sumar los valores de los totales de IVA en el objeto presupuesto.ivas
            let total = Object.values(totales).reduce(
                (total, valor) => total + valor,
                0
            );
            this.albaran.importe = total;
            return totales;
        },
        iva() {
            let ivas = {};
            this.albaran.lineas.forEach((elemento) => {
                let iva_linea = 0;
                let total_sin_iva = 0;
                let iva = this.ivas.find(
                    (element) => element.id == elemento.id_iva
                ).descripcion;

                total_sin_iva = elemento.total / (1 + parseInt(iva) / 100);
                iva_linea = (total_sin_iva * parseInt(iva)) / 100;
                elemento.iva = iva;

                // Agregar el IVA al tipo de IVA correspondiente en el objeto ivas
                if (elemento.iva in ivas) {
                    ivas[elemento.iva] += iva_linea;
                } else {
                    ivas[elemento.iva] = iva_linea;
                }
            });

            // Sumar los valores de los totales de IVA en el objeto presupuesto.ivas
            let totalIva = Object.values(ivas).reduce(
                (total, iva) => total + iva,
                0
            );
            this.albaran.iva = totalIva;
            return ivas;
        },
    },
    watch: {
        "albaran.id_cliente": function (val) {
            this.$store.dispatch("getDataCliente", val);
        },
    },
};
</script>
